export default {
  name: 'Content section - 16',
  tab: 'content',
  type: 'content-side-by-syde-section',
  content: {
    title: '',
    introtext: '<p>Photo by: Unsplash</p>',
    image: '/storage/media/samples/federica-galli-pF1ug8ysTtY-unsplash.jpg',
    buttons: '[]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '20px',
    'padding-bottom': '20px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h2',
    'introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    container: '1',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'end',
    'content-vertical-alignment': 'end',
    'image-size': 'lg',
    'image-position': 'right',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-rounded': '0'
  },
  advanced: {}
}
